import { render, staticRenderFns } from "./GenerationHistory.vue?vue&type=template&id=8f3b4fe6&"
import script from "./GenerationHistory.vue?vue&type=script&lang=js&"
export * from "./GenerationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports